module.exports = __webpack_public_path__ + "static/assets/7991a7aef7ebc1664ab688d59e555be7.png";